module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a8-5-bee4378ffbd4a4e4ca7efa63f4878922.jpg";